module.exports = __webpack_public_path__ + "static/media/push_pin.bd94a134.svg";